import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OrganizationService } from 'src/app/services/identity/organization.service';
import { ProfileService } from 'src/app/services/identity/profile.service';
import { ToastrHelper } from '../../../../helpers/toastr.helper';
import { CommunityWithRoles } from '../../../../models/identity/community-with-roles.model';
import { Organization } from '../../../../models/identity/organization.model';
import { User } from '../../../../models/identity/user.model';
import { Interest } from '../../../../models/skills/interest.model';
import { Skill } from '../../../../models/skills/skill.model';
@Component({
    selector: 'app-profile-modal',
    templateUrl: './profile-modal.component.html',
    styleUrls: ['./profile-modal.component.scss'],
})
export class ProfileModalComponent {
    @Input() visible: boolean = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    public interests: Interest[] = [];
    public notFilledInText = this.translateService.instant('shared.notFilledIn');
    public organization: Organization | null = null;
    public principalCommunity: CommunityWithRoles | null = null;
    public skills: Skill[] = [];
    public profile: User | null = null;

    constructor(
        private readonly profileService: ProfileService,
        private readonly toastrHelper: ToastrHelper,
        private readonly organizationService: OrganizationService,
        private readonly translateService: TranslateService,
        private readonly router: Router,
    ) {}

    @Input() set user(user: User | null) {
        this.loadUserProfile(user.userId);
    }

    closeModal() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    onHideModal() {
        this.visibleChange.emit(false);
    }

    private loadUserProfile(userId: string) {
        if (!userId) return;

        this.profileService.getUserProfileById(userId).subscribe({
            next: (user) => {
                this.profile = user;
                this.principalCommunity = user.communities?.find((c) => c.isPrimary) ?? null;
                this.skills = user.skills ?? [];
                this.interests = user.interests ?? [];

                if (user.organization?.id) {
                    this.loadOrganization(user.organization.id);
                } else {
                    this.organization = null;
                }
            },
            error: (error) => {
                this.toastrHelper.showGenericError(error);
            },
        });
    }

    private loadOrganization(orgId: string) {
        this.organizationService.getOrganizationById(orgId).subscribe({
            next: (data) => (this.organization = data),
            error: (error) => {
                this.toastrHelper.showGenericError(error);
            },
        });
    }
    goToDirectory() {
        this.closeModal();
        this.router.navigate(['/directory/members']);
    }
}
